export default "__VITE_ASSET__CKR9nRtW__"